import { useDarkMode } from '@leafygreen-ui/leafygreen-provider';
export const addCssVarPrefix = (color) => `var(--mdb-${color})`;
const useThemeValue = (isDarkMode) => {
    const { darkMode } = useDarkMode(isDarkMode);
    return ({ dark, light }) => addCssVarPrefix(darkMode ? dark : light);
};
export default useThemeValue;
